import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AdSenseService {

  protected initialized: boolean = false;
  protected adsEnabled: boolean = false;

  constructor() {
  }

  public initialize() {
  }

  public destroy() {
  }

  public enableAds(enable: boolean) {
    this.adsEnabled = enable;
    if (this.adsEnabled === true) {
      this.initialize();
    }
  }

}
